﻿'use strict';
import { jsPDF } from "jspdf";
// This code is used for backwards compatibility with the older jsPDF variable name
// Read more: https://github.com/MrRio/jsPDF/releases/tag/v2.0.0
//window.jsPDF = window.jspdf.jsPDF;
import { exportDataGrid } from "devextreme/pdf_exporter"

let erhebungDaten = null;
let ortsgemeindeDaten = null;
let grid = null;
let emailEditor = null;
let fixedErhebungGrid = false;
let validationSummary = null;
let gastSummeControl = null;
let mitgliedNummer = null;
let ortsgemeindenGrid = null;
let ortsgemeindenKontrollwerteInfo = null;
let customValidationSummary = null;

export function pageInit(loginResponse) {
    $("#common-head-title").html('Personalbestandserhebung <span class="highlight">' + loginResponse.jahr + '</span> online');
    $("#common-head-info").html('Lade Daten...');
    $("#common-foot-logout").html('<a href="#" id="common-logout" title="Abmelden ohne zu speichern.">Logout</a>');
    $("#common-logout").on("click", function (e) { e.preventDefault(); t.logout(true); });
    window.CONFIG.memberStatusCode = loginResponse.memberStatusCode;

    // Daten holen
    const url = new URL(window.CONFIG.serverApi + "/daten");
    const request = {
        cache: false,
        url: url,
        contentType: 'application/json',
        method: 'GET',
        headers: window.CONFIG.customHeaders,
        success: function (response) {
            initializeForm(response);
        },
        error: function (jqXHR) {
            t.showErrorInPage(jqXHR);
        }
    };
    $.ajax(request);
}
function initializeForm(erhebungsdatenResponse) {
    erhebungDaten = erhebungsdatenResponse.erhebungsdaten;
    //console.log(erhebungsdatenResponse)
    //console.log(erhebungDaten)
    const dates = {
        endeDatum: undefined,
        stichDatum: undefined
    }
    if (window.CONFIG.specialLogin === "neu") {
        dates.stichDatum = new Date(erhebungDaten.exBezugsdatum);
        dates.endeDatum = new Date(erhebungDaten.exEnde);
    } else {
        dates.stichDatum = new Date(erhebungsdatenResponse.jahr, 4, 31);
        dates.endeDatum = new Date(erhebungsdatenResponse.endeAngezeigt);
    }
    //$("#common-head-title").html(`Personalbestandserhebung <span class "highlight"> ${erhebungsdatenResponse.jahr}</span> zum Stichtag 31.05.${erhebungsdatenResponse.jahr}`);
    $("#common-head-title").html(`Personalbestandserhebung <span class "highlight">${erhebungsdatenResponse.jahr}</span> zum Stichtag ${dates.stichDatum.toLocaleDateString("de-de") }`);
    mitgliedNummer = erhebungsdatenResponse.mitgliedNummer;
    //let until = new Date(erhebungsdatenResponse.endeAngezeigt);
    let msg = `für <span class="highlight">${erhebungsdatenResponse.mitgliedName ?? "n/a"}</span> (Mitgliedsnummer ${mitgliedNummer ?? "n/a"})`;
    //msg += `<br/>online (bis ${until.toLocaleDateString("de-de")})`;
    msg += `<br/>online (bis ${dates.endeDatum.toLocaleDateString("de-de")})`;
    $("#common-head-info").html(msg);
    //$("#common-head-title").html(`Personalbestandserhebung <span class "highlight"> ${erhebungsdatenResponse.jahr}</span> online (bis ${until.toLocaleDateString("de-de")})`);
    //erhebungDaten = erhebungsdatenResponse.erhebungsdaten;
    if (erhebungsdatenResponse.erhebungOrtsgemeindedaten && erhebungsdatenResponse.erhebungOrtsgemeindedaten.length > 0) {
        ortsgemeindeDaten = erhebungsdatenResponse.erhebungOrtsgemeindedaten;
    }
    updateFooter();
    $("#survey").css("display", "block");
    $('#Bearbeiter').dxTextBox({
        value: erhebungDaten.bearbeiter ?? "",
        inputAttr: { 'aria-label': 'vollständiger Name Bearbeiter:in' },
        maxLength: 60,
        onValueChanged(e) { erhebungDaten.bearbeiter = e.value; },
    }).dxValidator({
        validationRules: [
            {
                type: 'required',
                message: 'Bitte geben Sie Ihren Namen an.'                
            },
            {
                type: 'stringLength',
                min: 8,
                max: 60,
                message: 'Bitte geben Sie mindestens 8 und höchstens 60 Zeichen für Ihren Namen an.'
            }
        ]
    });
    let email = $('#Email').dxTextBox({
        value: erhebungDaten.email ?? "",
        inputAttr: { 'aria-label': 'Email-Adresse' },
        maxLength: 150,
        onValueChanged(e) { erhebungDaten.email = e.value; }
    })
    email.dxValidator({
        validationRules: [
            {
                type: 'required',
                message: 'Bitte geben Sie eine Email-Adresse für eventuelle Rückfragen an.'
            },
            {
                type: 'email',
                message: 'Bitte geben sie eine gültige Email-Adresse an.'
            },
            {
                type: 'stringLength',
                max: 150,
                message: 'Die Email-Adresse ist zu lang. Maximal 150 Zeichen sind möglich.'
            }
        ]
    });
    emailEditor = email.dxTextBox("instance");
    $('#Telefon').dxTextBox({
        value: erhebungDaten.telefon ?? "",
        inputAttr: { 'aria-label': 'Telefonnummer Bearbeiter:in für Rückfragen' },
        maxLength: 35,
        onValueChanged(e) { erhebungDaten.telefon = e.value; },
        onKeyDown(e) {
            const evt = e.event;
            if (evt.key === 'Tab' && !evt.ctrlKey && !evt.shiftKey && !evt.altKey && grid) {
                const cell = grid.getCellElement(0, 'bs_Vollzeit');
                grid.focus(cell);
                grid.editCell(0, 'bs_Vollzeit');
            }
        }
    }).dxValidator({
        validationRules: [
            {
                type: 'required',
                message: 'Bitte geben Sie Ihre Telefonnummer für Rückfragen an.'
            },
            {
                type: 'stringLength',
                min: 8,
                max: 35,
                message: 'Bitte geben Sie mindestens 8 und höchstens 35 Zeichen für die Telefonnummer an.'
            }
        ]
    });
    customValidationSummary = $('#survey-validation-custom').dxValidationSummary().dxValidationSummary("instance");

    const columnDef = window.CONFIG.surveyHelper.Erhebung_DataColumnConfiguration();

    setupErhebungColumns(columnDef);
    if (window.CONFIG.memberStatusCode === 'M') {
        window.CONFIG.surveyHelper.Erhebung_PrepareRows(erhebungDaten.erhebungRows);
        erhebungDaten.erhebungRows.forEach((row) => {
            if (row.annotationId) {
                row.label += '<sup class="annotation">' + row.annotationId + '</sup>'; 
            }
        });
        $("#erhebung-daten-grid").dxDataGrid({
            dataSource: erhebungDaten.erhebungRows,
            keyExpr: 'rowTag',
            allowColumnResizing: false,
            allowColumnReordering: false,
            showBorders: true,
            showRowLines: true,
            showColumnLines: true,
            activeStateEnabled: true,
            rowAlternationEnabled: true,
            width: "100%",
            //height: "80vh",
            scrolling: {
                //mode: 'virtual',
                showScrollbar: 'always',
                useNative: true
            },
            sorting: { mode: "none" },
            keyboardNavigation: {
                editOnKeyPress: true,
                enabled: true,
                enterKeyAction: "moveFocus",
                enterKeyDirection: "row"
            },
            editing: {
                allowAdding: false,
                allowDeleting: false,
                allowUpdating: true,
                mode: "cell",
                selectTextOnEditStart: true
            },
            onEditingStart: function (e) {
                // prüfen, ob editiert werden kann; Summenspalten müssen wir hier nicht prüfen, weil die schon in der Spaltendefinition nicht editierbar gesetzt wurden 
                let rowTag = e.data.rowTag;
                if (window.CONFIG.surveyHelper.Erhebung_Info.sumRows.includes(rowTag)) {
                    e.cancel = true; // Summenzeile => kein Editieren
                    return;
                }
                let omitDef = window.CONFIG.surveyHelper.Erhebung_Info.omitRows.find(o => o.rowName === rowTag);
                if (omitDef) {
                    if (omitDef.columns.includes(e.column.dataField)) {
                        e.cancel = true; // "ausgelassene" Zelle  => kein Editieren
                        return;
                    }
                }
            },
            onRowUpdated: function (e) {
                // Summen neu berechnen
                window.CONFIG.surveyHelper.Erhebung_ReCalculate(e.data.rowTag, erhebungDaten.erhebungRows);
                e.component.refresh();
                if (ortsgemeindeDaten) {
                    updateOrtsgemeindedatenKontrollwerte();
                    ortsgemeindenGrid.refresh();
                }
            },
            onEditorPreparing: function (onEditorPreparingEvent) {
                // einige Eingaben (z.B. "e") ergeben als Wert null, wird hier auf 0 korrigiert
                // und falls ein Schlaumi mit halben Beschäftigten rechnen will => Nachkommastellen werden abgeschnitten
                const defaultValueChangeHandler = onEditorPreparingEvent.editorOptions.onValueChanged;
                onEditorPreparingEvent.editorOptions.onValueChanged = (onValueChangedEvent) => {
                    const value = onValueChangedEvent.value;
                    if (value == null) {
                        onEditorPreparingEvent.setValue(0);
                        // onEditorPreparingEvent statt onValueChangedEvent ist Absicht (onValueChangedEvent.component ist der Editor (hier dxTextBox),
                        // onEditorPreparingEvent.component ist ein Spalten - Objekt, das die Methode setValue hat)
                    } else if (!Number.isInteger(value)) {
                        onEditorPreparingEvent.setValue(Math.trunc(value));
                    } else {
                        defaultValueChangeHandler(onValueChangedEvent);
                    }
                };

                if (onEditorPreparingEvent.row.rowIndex == 0 && onEditorPreparingEvent.dataField === "bs_Vollzeit") {
                    // erste Zelle: Shift-Tab zurück zu #Email
                    onEditorPreparingEvent.editorOptions.onKeyDown = (e) => {
                        const evt = e.event;
                        if (evt.key === 'Tab' && !evt.ctrlKey && evt.shiftKey && !evt.altKey) {
                            evt.stopPropagation();
                            evt.preventDefault();
                            grid.closeEditCell();
                            setTimeout(function () { emailEditor.focus(); }, 100);
                        }
                    }
                }
            },
            onContentReady: function (e) {
                // Spaltenköpfe mit Umbruch werden wie gewünscht horizontal zentriert (=> setupErhebungColumns, Zuweisung an headerCellTemplate).
                // Spaltenköpfe mit Umbruch werden aber wegen der expliziten Zuweisung von "text-align: right" via style-Attribut des td-Elements
                // rechtsbundig angezeigt. Hier reparieren wir das (mit dem Holzhammer)
                if (!fixedErhebungGrid) {
                    let i = 0;
                    let col = e.component.columnOption(i);
                    while (col) {
                        if (col.dataField) {
                            $("#" + col.headerId).css("text-align", "center");
                        }
                        col = e.component.columnOption(++i);
                    }
                    grid = e.component;

                    // tabIndex-Attribut von den Header-Zellen entfernen (dann sind sie raus aus der Tab-Order)
                    const gridElement = e.element[0];
                    const headerArea = gridElement.querySelector('.dx-datagrid-headers');
                    headerArea.querySelectorAll('[tabindex]').forEach((header) => {
                        header.removeAttribute('tabIndex');
                    });
                    // und die annotations verlinken
                    $(".annotation").each(function (i) {
                        const id = $(this).text();
                        this.onclick = function () { showAnnotation(id); }
                        this.title = "Hier klicken für weitere Informationen.";
                    });
                    fixedErhebungGrid = true;
                }
            },
            onCellPrepared(e) {
                if (e.rowType === "data" && null == e.value ) { // "ausgegraute" Zellen
                    e.cellElement.addClass("notAvailable");
                }
            }, 
            columns: columnDef
        }) // dxDataGrid Erhebungsdaten
        if (ortsgemeindeDaten) {
            prepareOrtsgemeindeDaten(ortsgemeindeDaten);
            const ortsgemeindeColDef = [
                {
                    caption: "",
                    dataField: "bezeichnung",
                    width: "60%",
                    allowEditing: false,
                    cellTemplate(element, cellData) {
                        $('<div class="ortsgemeidedaten-col-bezeichnung-data grid-cell-multiline">')
                            .appendTo(element)
                            .html(cellData.text);
                    },
                    headerCellTemplate: ortsgemeindeHeaderCellTemplate
                },
                {
                    caption: "insgesamt",
                    dataField: "gesamt",
                    headerCellTemplate: ortsgemeindeHeaderCellTemplate,
                    validationRules: [
                        {
                            type: "custom",
                            ignoreEmptyValue: true,
                            message: 'Summe "Sozial- und Erziehungsdienst" und "BezTV-W RP" ist größer als die Gesamtzahl (Spalte "Insgesamt")',
                            validationCallback(v) {
                                return v.data.sozErzDienst + v.data.forst <= v.value;
                            }
                        }
                    ]
                },
                {
                    caption: "<u>davon</u> im Sozial- und Erziehungsdienst",
                    dataField: "sozErzDienst",
                    headerCellTemplate: ortsgemeindeHeaderCellTemplate,
                    validationRules: [
                        {
                            type: "custom",
                            ignoreEmptyValue: true,
                            message: 'Summe "Sozial- und Erziehungsdienst" und "BezTV-W RP" ist größer als die Gesamtzahl (Spalte "Insgesamt")',
                            validationCallback(v) {
                                return v.value + v.data.forst <= v.data.gesamt;
                            }
                        }
                    ]
                },
                {
                    caption: "<u>davon</u> im BezTV-W RP",
                    dataField: "forst",
                    headerCellTemplate: ortsgemeindeHeaderCellTemplate,
                    validationRules: [
                        {
                            type: "custom",
                            ignoreEmptyValue: true,
                            message: 'Summe "Sozial- und Erziehungsdienst" und "BezTV-W RP" ist größer als die Gesamtzahl (Spalte "Insgesamt")',
                            validationCallback(v) {
                                return v.data.sozErzDienst + v.value <= v.data.gesamt;
                            }
                        }
                    ]
                }
            ]
            $("#erhebung-ortsgemeindedaten").css("display", "block");
            $("#erhebung-ortsgemeindedaten-grid").dxDataGrid({
                dataSource: ortsgemeindeDaten,
                keyExpr: 'recordId',
                allowColumnResizing: false,
                allowColumnReordering: false,
                showBorders: true,
                showRowLines: true,
                showColumnLines: true,
                activeStateEnabled: true,
                rowAlternationEnabled: true,
                width: "100%",
                scrolling: {
                    showScrollbar: 'always',
                    useNative: false
                },
                sorting: { mode: "none" },
                keyboardNavigation: {
                    editOnKeyPress: true,
                    enabled: true,
                    enterKeyAction: "moveFocus",
                    enterKeyDirection: "row"
                },
                editing: {
                    allowAdding: false,
                    allowDeleting: false,
                    allowUpdating: true,
                    mode: "cell",
                    selectTextOnEditStart: true
                },
                paging: {
                    enabled: false
                },
                onCellPrepared(e) {
                    if (e.rowType === "data" && null == e.value) { // "ausgegraute" Zellen
                        e.cellElement.addClass("notAvailable");
                    }
                    if (e.data?.zeilenart && e.data.zeilenart === "T") {
                        if (ortsgemeindenKontrollwerteInfo.felder.includes(e.column.dataField)) {
                            const kontrollwert = ortsgemeindenKontrollwerteInfo.ortsgemeindenRowKontrollWerte[e.column.dataField];
                            let classname = null;
                            if (e.value != 0) {
                                if (e.value == kontrollwert) {
                                    classname = 'grid-cell-value-good'
                                } else if (e.value > kontrollwert) {
                                    classname = 'grid-cell-value-toobig'
                                } else {
                                    classname = 'grid-cell-value-toosmall'
                                }
                            }
                            if (classname) {
                                e.cellElement.addClass(classname);
                            }
                        }
                    }
                },
                onContentReady(e) {
                    ortsgemeindenGrid = e.component;
                },
                onRowUpdated(e) {
                    // Summen neu berechnen
                    ortsgemeindedatenSummenCalc()
                    e.component.refresh();
                },
                onEditingStart(e) {
                    if (e.data.zeilenart === "T" || e.data.zeilenart.length > 1 ) { // Summenzeile ist nicht editierbar, ebensowenig eingefügte Zwischenzeilen
                        e.cancel = true;
                    }
                },
                onEditorPreparing(onEditorPreparingEvent) {
                    // einige Eingaben (z.B. "e") ergeben als Wert null, wird hier auf 0 korrigiert
                    // und falls ein Schlaumi mit halben Beschäftigten rechnen will => Nachkommastellen werden abgeschnitten
                    const defaultValueChangeHandler = onEditorPreparingEvent.editorOptions.onValueChanged;
                    onEditorPreparingEvent.editorOptions.onValueChanged = (onValueChangedEvent) => {
                        const value = onValueChangedEvent.value;
                        if (value == null) {
                            onEditorPreparingEvent.setValue(0);
                            // onEditorPreparingEvent statt onValueChangedEvent ist Absicht (onValueChangedEvent.component ist der Editor (hier dxTextBox),
                            // onEditorPreparingEvent.component ist ein Spalten - Objekt, das die Methode setValue hat)
                        } else if (!Number.isInteger(value)) {
                            onEditorPreparingEvent.setValue(Math.trunc(value));
                        } else {
                            defaultValueChangeHandler(onValueChangedEvent);
                        }
                    };
                },
                columns: ortsgemeindeColDef
            }) // dxDataGrid ErhebungOrtsgemeindedaten
        }

    } else {
        // Gastmitglied
        // Fix Nulls
        erhebungDaten.gast_Angestellte = erhebungDaten.gast_Angestellte ?? 0;
        erhebungDaten.gast_Azubis = erhebungDaten.gast_Azubis ?? 0;
        erhebungDaten.gast_Gesamt = erhebungDaten.gast_Angestellte + erhebungDaten.gast_Azubis;
        const checkNotNegative = function (e) { return isNaN(e.value) || e.value >= 0 };
        const NotNegativeValidation = {
            type: "custom",
            message: "Für die Beschäftigtenzahl bitte eine Zahl gleich oder größer Null angeben.",
            validationCallback: checkNotNegative
        }
        $("#erhebung-daten-gastmitglied").css("display", "grid");

        $('#Gast_Angestellte').dxNumberBox({
            value: erhebungDaten.gast_Angestellte,
            inputAttr: { 'aria-label': 'Beschäftigte gesamt' },
            min: 0,
            format: '#',
            onValueChanged(e) { erhebungDaten.gast_Angestellte = e.value; updateGastSumme(erhebungDaten); },
        }).dxValidator({
            validationRules: [
                {
                    type: 'required',
                    message: 'Bitte geben Sie die Anzahl aller Beschäftigten an.'
                },
                NotNegativeValidation
            ]
        });
        $('#Gast_Azubis').dxNumberBox({
            value: erhebungDaten.gast_Azubis ?? 0,
            inputAttr: { 'aria-label': 'Auszubildende gesamt' },
            min: 0,
            format: '#',
            onValueChanged(e) { erhebungDaten.gast_Azubis = e.value; updateGastSumme(erhebungDaten); },
        }).dxValidator({
            validationRules: [
                {
                    type: 'required',
                    message: 'Bitte geben Sie die Anzahl aller Auszubildenden an.'
                },
                NotNegativeValidation
            ]
        });
        gastSummeControl = $('#Gast_Gesamt').dxNumberBox({
            value: erhebungDaten.gast_Gesamt ?? 0,
            inputAttr: { 'aria-label': 'Beschäftigte gesamt' },
            min: 0,
            format: '#',
            readOnly: true
        }).dxNumberBox('instance');

    }
    validationSummary = $('#survey-validation').dxValidationSummary({        
    }).dxValidationSummary('instance');

    $("#survey-btn-save").dxButton({
        text: 'Speichern',
        icon: 'floppy',
        type: 'success',
        onClick(e) { save(e) }

    });
    $("#survey-btn-save-and-close").dxButton({
        text: 'Speichern & Logout',
        icon: 'check',
        type: 'success',
        onClick(e) { saveAndLogout(e) }
    });

}
function setupErhebungColumns(columnDef) {
    // Achtung: dieser Code geht von Annahmen über die Konfiguration aus:
    // Matrix.ShortNameHeading = true bei der Generierung
    // 1. Spalte => ShortName
    // 2. Spalte => Label
    // alle anderen: Beschäftigenzahlen
    
    let column = columnDef[0].columns[0].columns[0] // Nr.
    column.width = 35;

    column = columnDef[0].columns[1].columns[0] // Sparte
    column.width = 225;
    column.cellTemplate = function (element, info) {    // Spalte Sparte mit Umbruch in den Zellen
        $("<div>")
            .appendTo(element)
            .html('<div class="erhebung-col-sparte">' + info.value + '</div>')
            .css("width", info.column.width - 10) 
            .css("height", "auto")
            .css("white-space", "normal")
            .css("overflow-wrap", 'break-word');
    }

    for (let i = 0; i < columnDef.length; i++) {
        const group = columnDef[i];  // Gruppen
        group.alignment = "center";  // Ausrichtung Gruppe-Kopf
        group.headerCellTemplate = function (element, info) {
            $('<div>')
                .appendTo(element)
                .text(group.caption)
                .css("font-weight", "bold");
        } 

        
        for (const shortname of group.columns) {
            shortname.alignment = "center";   //  A, B, C, D, E, ...
            const column = shortname.columns[0];    // die eigentlichen Spalten
           
            if (column.mwitc && column.mwitc.widthHint) { // das sind die Spalten ab C
                let extra = 0;
                if (column.mwitc.widthHint >= -1) {
                    extra = column.mwitc.widthHint * 15;
                }
                column.width = 85 + extra;
            }
            if (i > 1) {
                column.alignment = "right";
            }
            let src = '<div class="erhebung-col-head">' + column.caption
            if (column.mwitc && column.mwitc.annotationId) {
                src += '<sup class="annotation">' + column.mwitc.annotationId + '</sup>';
            }
            src += '</div>'
            column.headerCellTemplate = function (element, info) {
                $('<div>')
                    .appendTo(element)
                    .html(src)
                    .css("text-align", "center")
                    .css("width", "100%")
                    .css("display", "table-cell")
                    .css("height", "auto")
                    .css("white-space", "normal")
                    .css("overflow-wrap", 'break-word');
                
            } 
        }
    }
}
function saveAndLogout(event) {
    save(event, true);
}
async function save(event, logout) {
    if (window.CONFIG.memberStatusCode === 'M') {
        await grid.saveEditData(); // sonst wird evtl. nicht gespeichert...
    }
    if (ortsgemeindeDaten) {
        await ortsgemeindenGrid.saveEditData();
    }
    let result = event.validationGroup.validate();
    const errors = [];
    if (ortsgemeindeDaten) {
        // Summen OG gegen PBE Summen prüfen
        updateOrtsgemeindedatenKontrollwerte();
        if (ortsgemeindenKontrollwerteInfo.ortsgemeindenRowSummen.gesamt != ortsgemeindenKontrollwerteInfo.erhebungRowGesamt.gesamtsumme) {
            errors.push("Gesamtzahl der Beschäftigten und Auszubildenden in der Personalbestandserhebung stimmt nicht mit der Gesamtzahl der Beschäftigten und Auszubildenden der Ortsgemeinden und der Verbandsgemeinde überein.");
        }
        if (ortsgemeindenKontrollwerteInfo.ortsgemeindenRowSummen.forst != ortsgemeindenKontrollwerteInfo.erhebungRowForst.gesamtsumme) {
            errors.push("Gesamtzahl der Beschäftigten und Auszubildenden BezTV-W RP in der Personalbestandserhebung stimmt nicht mit der Gesamtzahl der Beschäftigten und Auszubildenden BezTV-W RP der Ortsgemeinden und der Verbandsgemeinde überein.");
        }
        customValidationSummary.option("items", errors);
    }
    if (result.isValid && errors.length == 0) {
        const info = window.CONFIG.surveyHelper.Erhebung_Info;
        let total = 0;
        if (window.CONFIG.memberStatusCode === 'M') {
            total = erhebungDaten.erhebungRows[info.totalRowPosition][info.totalColumnField];
        } else {
            total = erhebungDaten.gast_Gesamt;
        }

        if (total == 0) {
            let dlg = DevExpress.ui.dialog.confirm("Hat das KAV-Mitglied wirklich <b>keine</b> Mitarbeiter? ", "Bitte bestätigen Sie!");
            dlg.done(function (dialogResult) {
                if (dialogResult) {
                    saveExecute(logout);
                }
            });
        } else {
            saveExecute(logout);
        }
    }
}
function saveExecute(logout) {
    const url = new URL(window.CONFIG.serverApi + "/daten");
    const daten = {
        erhebungsdaten: erhebungDaten,
        erhebungOrtsgemeindedaten: null
    }
    if (ortsgemeindeDaten) {
        daten.erhebungOrtsgemeindedaten = ortsgemeindeDaten.filter(r => r.zeilenart.length == 1);
    }
    const request = {
        cache: false,
        url: url,
        contentType: 'application/json',
        method: 'PUT',
        headers: window.CONFIG.customHeaders,
        data: JSON.stringify(daten),
        success: function (response) {
            erhebungDaten = response.erhebungsdaten;
            if (window.CONFIG.memberStatusCode === 'M') {
                window.CONFIG.surveyHelper.Erhebung_PrepareRows(erhebungDaten.erhebungRows);
                // grid refreshen
                grid.option('dataSource', erhebungDaten.erhebungRows);
            } else {
                // Todo: gast_Gesamt Anzeige aktualisieren

            }
            updateFooter();
            // die anderen Editoren müssen nicht aktualisiert werden, hier finden keine Korrekturen durch den WebService statt
            // emailEditor.option('value', erhebungDaten.Email);
            let dlg = DevExpress.ui.dialog.confirm("Wollen Sie eine Kopie der angegebenen Mitarbeiterzahlen als PDF-Datei speichern?", "Beleg-Kopie erstellen");
            dlg.done(function (dialogResult) {
                (dialogResult ? exportToPdf() : Promise.resolve()).
                    then(() => {
                        if (logout) {
                            t.logout();
                            if (dialogResult) {
                                // das Erzeugen der PDF-Datei erfolgt asynchron, und ich habe es nicht geschafft, darauf zu warten. Deshalb diese Krücke...
                                DevExpress.ui.dialog.alert("Sie wurden abgemeldet.", "KAV RP Online").done(() => location.reload());
                            } else {
                                location.reload();
                            }
                        }
                    });
            });

            let direction = 'up-push';
            let position = 'bottom center';
            DevExpress.ui.notify({
                message: "Erhebungsdaten wurden gespeichert.",
                height: 60,
                width: 400,
                minWidth: 400,
                displayTime: 5000,
                closeOnClick: true,
                hideOnOutsideClick: true,
                type: "success"
            },
            {
                position,
                direction
            });
        },
        error: function (jqXHR) {
            console.error(jqXHR)
            //if (jqXHR.responseJSON && jqXHR.responseJSON.code) {
                t.showRequestErrorInDialog("Fehler beim Speichern der Personalbestandserhebung", jqXHR, validationSummary);
            //} else {
            //    t.showErrorInPage(jqXHR);
            //}
        }
    };
    $.ajax(request);

}

function updateGastSumme(erhebungDaten) {
    erhebungDaten.gast_Gesamt = erhebungDaten.gast_Angestellte + erhebungDaten.gast_Azubis;
    // Anzeige aktualisieren
    gastSummeControl.option("value", erhebungDaten.gast_Gesamt);
}
function showAnnotation(id) {
    const anno = window.CONFIG.surveyHelper.Erhebung_Info.annotations.find((a) => a.id === id);
    $("#survey_popup").dxPopup({
        title: "Anmerkung " + id,
        visible: true,
        hideOnOutsideClick: true,
        hideOnOutsideClick: true,
        showCloseButton: true,
        shading: false,
        width: "800px",
        height: "auto",
        contentTemplate: function (contentElement) {
            contentElement.append($('<div class="annotation_popup">').html(anno.text));
        }
    });
}

const pdfExportConfig = Object.freeze({
    defaultHorizontalPadding: 0.75,
    labelHorizontalPadding: 0.5, 
    headerVerticalPadding: 1, // vertical padding for header cells
    documentMargins: { top: 20, left: 15, bottom: 10, right: 15 }
})
function exportToPdf() {
    let ret = null;
    if (window.CONFIG.memberStatusCode === 'M') {
        ret = exportGridToPdf(grid);
    } else {
        ret = exportGastmitglied2Pdf();
    }
    return ret;
}

function exportGastmitglied2Pdf() {
    const doc = new jsPDF({
        putOnlyUsedFonts: true
    });
    const fontName = doc.getFont().fontName;
    const pages = doc.internal.getNumberOfPages();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // header
    const header = `Personalbestandserhebung ${erhebungDaten.jahr} Gastmitglied`;
    doc.setFont(fontName, "", "bold");
    doc.setFontSize(14);
    const headerWidth = doc.getTextDimensions(header).w;
    doc.text(header, (pageWidth - headerWidth) / 2, 14);
    // footer
    let footer = `Stand: ${new Date(erhebungDaten.datum).toLocaleString("de-de", { timeStyle: "medium", dateStyle: "medium" })} / Bearbeiter: ${erhebungDaten.bearbeiter ?? "<k.A.>"} für KAV-Mitglied ${mitgliedNummer}`;
    doc.setFont(fontName, "", "normal");
    doc.setFontSize(9);
    let footerWidth = doc.getTextDimensions(footer).w;
    doc.setTextColor('#222222');
    doc.text(footer, (pageWidth - footerWidth) / 2, pageHeight - 16);
    // Text
    doc.setFontSize(12);
    const leftText = 75;
    const leftValue = leftText + 45;
    let y = 60;
    doc.text("Beschäftigte", leftText, y);
    doc.text(erhebungDaten.gast_Angestellte.toString(), leftValue, y);
    y += 10;
    doc.text("Auszubildende", leftText, y);
    doc.text(erhebungDaten.gast_Azubis.toString(), leftValue, y);
    y += 10;
    doc.text("Gesamt", leftText, y);
    doc.text(erhebungDaten.gast_Gesamt.toString(), leftValue, y);

    return doc.save(`Personalbestandserhebung ${erhebungDaten.jahr}.pdf`, { returnPromise: true });
}


function exportGridToPdf(gridComponent) {
    const doc = new jsPDF({ // 
        unit: 'mm', format: 'a4', // => defaults
        orientation: 'landscape',
        putOnlyUsedFonts: true
    });
    doc.mwitc = { calculate: true };
    const lastPoint = { x: 0, y: 0 };
    const promise = DevExpress.pdfExporter.exportDataGrid({
        jsPDFDocument: doc,
        component: gridComponent,
        //margin: { top: 20, left: 15, bottom: 10, right: 15 },
        margin: pdfExportConfig.documentMargins,
        // Reihenfolge des Aufrufs der Callbacks:
        // - erst für alle Zellen customizeCell
        // - dann für alle Spalten onRowExporting
        // - und zuletzt für alle Zellen customDrawCell
        customizeCell(options) {
            pdfCellCustomizeErhebungGrid(options);
        },
        customDrawCell(options) {
            const { rect, gridCell, pdfCell, doc } = options;
            if (gridCell.rowType === 'header' && gridCell.column.mwitc != null) {
                options.cancel = true; // Header-Zellen nicht zeichnen lassen, wir zeichnen sie hier selbst
                calculateTextMetrics(doc);
                // Text ermitteln und ggf. umbrechen
                const text = (gridCell.column.mwitc.labeltext ?? gridCell.column.caption).replaceAll("&shy;", "");
                const textlines = doc.splitTextToSize(text, rect.h - 2 * pdfExportConfig.headerVerticalPadding);
                // Text rotiert zentriert in die Header-Zelle schreiben
                const textHeight = doc.mwitc.headerLineHeight * textlines.length + (textlines.length == 1 ? 0 : doc.mwitc.headerSpacingHeight * (textlines.length - 1));
                const remainingWidth = rect.w - textHeight;
                const xOffset = remainingWidth / 2 + doc.mwitc.headerLineHeight;
                //doc.text(textlines, rect.x + doc.mwitc.headerLineHeight + pdfExportConfig.defaultHorizontalPadding, rect.y + rect.h - pdfExportConfig.headerVerticalPadding, { align: "left", angle: 90 })
                doc.text(textlines, rect.x + xOffset, rect.y + rect.h - pdfExportConfig.headerVerticalPadding, { align: "left", angle: 90 })
            }
            // "unteres Ende" der Tabelle für den zu druckenden Fuß ermitteln
            if (lastPoint.x < rect.x + rect.w) {
                lastPoint.x = rect.x + rect.w;
            }
            if (lastPoint.y < rect.y + rect.h) {
                lastPoint.y = rect.y + rect.h;
            }
        }
    }).then(() => {
        if (ortsgemeindeDaten) {
            const lastPoint = { x: 0, y: 0 };
            doc.addPage();
            const promise = DevExpress.pdfExporter.exportDataGrid({
                component: ortsgemeindenGrid,
                jsPDFDocument: doc,
                margin: pdfExportConfig.documentMargins,
                customizeCell(options) {
                    pdfCellCustomizeOrtsgemeindenGrid(options);
                },
                customDrawCell(options) {
                    const { rect } = options;
                    // "unteres Ende" der Tabelle für den zu druckenden Fuß ermitteln
                    if (lastPoint.x < rect.x + rect.w) {
                        lastPoint.x = rect.x + rect.w;
                    }
                    if (lastPoint.y < rect.y + rect.h) {
                        lastPoint.y = rect.y + rect.h;
                    }
                }
            });
            return promise;
        } else {
            return Promise.resolve();
        }
    }).then(() => {
        const fontName = doc.getFont().fontName;
        const pages = doc.internal.getNumberOfPages();
        // header
        const header = `Personalstandserhebung ${erhebungDaten.jahr}`;
        const pageWidth = doc.internal.pageSize.getWidth();
        const headerWidth = doc.getTextDimensions(header).w;

        for (let i = 1; i <= pages; i++) {
            doc.setPage(i);
            doc.setFont(fontName, "", "bold");
            doc.setFontSize(14);
            doc.text(header, (pageWidth - headerWidth) / 2, 14);
            // footer
            let footer = `Stand: ${new Date(erhebungDaten.datum).toLocaleString("de-de", { timeStyle: "medium", dateStyle: "medium" })} / Bearbeiter: ${erhebungDaten.bearbeiter ?? "<k.A.>"} für KAV-Mitglied ${mitgliedNummer} / Seite ${i}`;
            let footerWidth = doc.getTextDimensions(footer).w;
            doc.setFont(fontName, "", "normal");
            doc.setFontSize(9);
            doc.setTextColor('#222222');
            doc.text(footer, (lastPoint.x - footerWidth), lastPoint.y + 10);
        }
        const ret =  doc.save(`Personalbestandserhebung ${erhebungDaten.jahr}.pdf`, { returnPromise: true});
        return ret;
    });
    return promise;   
}
function calculateTextMetrics(doc) {
    if (doc.mwitc.calculate) {
        doc.mwitc.calculate = false;
        const dim1line = doc.getTextDimensions("AQ");
        const dim2lines = doc.getTextDimensions(["AQ", "AQ"]);
        doc.mwitc.headerLineHeight = dim1line.h;
        doc.mwitc.headerSpacingHeight = dim2lines.h - 2 * dim1line.h;
        console.log("Text-Metriken für PDF-Export:", doc.mwitc);
    }
}

function pdfCellCustomizeErhebungGrid({ gridCell, pdfCell }) {
    const column = gridCell.column;
    const dataField = column.dataField;
    pdfCell.borderColor = "#000000";
    pdfCell.textColor = "#000000";

    // Ränder schmaler
    pdfCell.padding.left = pdfExportConfig.defaultHorizontalPadding;
    pdfCell.padding.right = pdfExportConfig.defaultHorizontalPadding;

    if (gridCell.rowType === 'header') {
        if (column.mwitc && column.mwitc.labeltext) {
            pdfCell.text = column.mwitc.labeltext;
        }
        if (pdfCell.text === "Gesamtsumme") pdfCell.text = "Gesamt"; // HÄSSLICH!
        if (gridCell.column.isBand) {   // die ersten beiden Zeilen (= "Über"header)
            pdfCell.horizontalAlign = "center"
        } else {
            pdfCell.horizontalAlign = "left"
            // Umbruch
            pdfCell.wordWrapEnabled = true;
        }
        //pdfCell.text = pdfCell.text.replaceAll('&shy;', '');
    } else if (gridCell.rowType === 'data') {
        switch (dataField) {
            //case 'shortName':
            //    break;
            case 'label':
                // Ränder noch schmaler
                pdfCell.padding.left = pdfExportConfig.labelHorizontalPadding;
                pdfCell.padding.right = pdfExportConfig.labelHorizontalPadding;
                // Text ohne HTML (vorerst!)
                pdfCell.text = gridCell.data.labeltext;
                // Umbruch
                pdfCell.wordWrapEnabled = true;
                break;
        }
        if (!pdfCell.text) {
            pdfCell.backgroundColor = "#C0C0C0";
        }
    }
}
function pdfCellCustomizeOrtsgemeindenGrid({ gridCell, pdfCell }) {
    const column = gridCell.column;
    const dataField = column.dataField;
    pdfCell.borderColor = "#000000";
    pdfCell.textColor = "#000000";
    // Ränder schmaler
    pdfCell.padding.left = pdfExportConfig.defaultHorizontalPadding;
    pdfCell.padding.right = pdfExportConfig.defaultHorizontalPadding;
    if (pdfCell.text) {
        // Text ohne HTML
        pdfCell.text = pdfCell.text.replace(/(<([^>]+)>)/ig, '');
        // aber mit Umbruch
        pdfCell.wordWrapEnabled = true;
    }
    if (gridCell.rowType === 'data') {
        if (pdfCell.text) {
            if (pdfCell.text.indexOf('eschäftigt') > 0) {
                if (gridCell.data.recordId === 'A1') {
                    pdfCell.text = "Beschäftigte und Auszubildende der Ortsgemeinden"
                }
            }
        } else {
            pdfCell.backgroundColor = "#C0C0C0";
        }
    }
}

function updateFooter() {
    let msg = "";
    if (erhebungDaten.datum) {
        msg = `zuletzt bearbeitet am ${new Date(erhebungDaten.datum).toLocaleString("de-de", { timeStyle: "medium", dateStyle: "medium" })}`;
    }
    $("#common-foot-info").html(msg);
}
function ortsgemeindeHeaderCellTemplate (element, columnData) {
    $('<div class="ortsgemeidedaten-headers grid-cell-multiline">')
        .appendTo(element)
        .html(columnData.column.caption);
} 
function prepareOrtsgemeindeDaten(ortsgemeindeDaten) {
    ortsgemeindeDaten[0].bezeichnung = '<span class="ortsgemeinde-headline-in-data">Beschäftigte und Auszubildende <u>nur</u> der Verbandsgemeinde</span>';
    const ortsgemeindeHeader = {
        bezeichnung: '<span class="ortsgemeinde-headline-in-data">Beschäftigte und Auszubildende der Ortsgemeinden</span><br/>(Hier sind <u><b>alle</b></u> Ortsgemeinden aufzuführen, auch wenn eine Ortsgemeinde die Mitgliedschaft zu unserem Verband nicht besitzt. <b>Beschäftigte von Zweckverbänden sind nicht aufzuführen.</b>)',
        zeilenart: 'A1',
        recordId: 'A1' 
    }
    ortsgemeindeDaten.splice(1, 0, ortsgemeindeHeader);
    const sumRow = ortsgemeindeDaten.at(-1);
    sumRow.bezeichnung = '<span class="ortsgemeinde-headline-in-data">' + sumRow.bezeichnung + '</span>';
    const kontrollWerte = {
        bezeichnung: 'Kontrollwerte (aus Spalte <b>P</b> der Personalbestandserhebung)',
        zeilenart: 'T1',
        recordId: 'T1'
    }
    ortsgemeindeDaten.push(kontrollWerte);
    ortsgemeindenKontrollwerteInfo = {
        ortsgemeindenRowKontrollWerte: kontrollWerte,
        ortsgemeindenRowSummen: ortsgemeindeDaten.at(-2),
        felder: ["gesamt", "forst"],
        erhebungRowForst: erhebungDaten.erhebungRows.find(r => r.rowTag === 'Wald'),
        erhebungRowGesamt: erhebungDaten.erhebungRows.find(r => r.rowTag === 'Gesamt')

    }
    updateOrtsgemeindedatenKontrollwerte();
}
function updateOrtsgemeindedatenKontrollwerte() {
    ortsgemeindenKontrollwerteInfo.ortsgemeindenRowKontrollWerte.forst = ortsgemeindenKontrollwerteInfo.erhebungRowForst?.gesamtsumme;
    ortsgemeindenKontrollwerteInfo.ortsgemeindenRowKontrollWerte.gesamt = ortsgemeindenKontrollwerteInfo.erhebungRowGesamt?.gesamtsumme;
}
function ortsgemeindedatenSummenCalc() {
    const accumulator = {
        gesamt: 0,
        sozErzDienst: 0,
        forst: 0
    }
    const gesamt = ortsgemeindeDaten.filter(r => r.zeilenart == "A" || r.zeilenart == "D").reduce(
        (acc, r) => {
            acc.gesamt += r.gesamt;
            acc.sozErzDienst += r.sozErzDienst;
            acc.forst += r.forst;
            return acc;
        }, accumulator);
    const sumRow = ortsgemeindenKontrollwerteInfo.ortsgemeindenRowSummen;
    sumRow.gesamt = accumulator.gesamt;
    sumRow.sozErzDienst = accumulator.sozErzDienst;
    sumRow.forst = accumulator.forst;
}